import { render, staticRenderFns } from "./SearchGeoNovation.vue?vue&type=template&id=2ae6e580&"
import script from "./SearchGeoNovation.vue?vue&type=script&lang=js&"
export * from "./SearchGeoNovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports